import { configureStore, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';

const TENANT_KEY = 'yardpay.tenant';
const read = () => {
  try { return localStorage.getItem(TENANT_KEY); } catch { return null; }
};

interface SessionState {
  signedIn: boolean;
  tenantId: string | null;
}

const session = createSlice({
  name: 'session',
  initialState: { signedIn: false, tenantId: read() } as SessionState,
  reducers: {
    signedIn(s, a: PayloadAction<boolean>) {
      s.signedIn = a.payload;
      if (!a.payload) s.tenantId = null;
    },
    selectTenant(s, a: PayloadAction<string | null>) {
      s.tenantId = a.payload;
      try {
        if (a.payload) localStorage.setItem(TENANT_KEY, a.payload);
        else localStorage.removeItem(TENANT_KEY);
      } catch { /* storage non disponibile */ }
    },
  },
});

export const { signedIn, selectTenant } = session.actions;

export function makeStore() {
  return configureStore({ reducer: { session: session.reducer } });
}
export const store = makeStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
